import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Typed from "react-typed";
import image from "../../../abuhorain.png";
import "./Header.css";

const Header = () => {
  return (
    <section className="header container">
      <div className="row my-5">
        <div className="col-md-6 order-2 order-md-1">
          <h1 className="">
            Hi, <br /> I'm Md.{" "}
            <span style={{ color: "#DF3A01" }}>Abu Horain</span>,{" "}
          </h1>
          <br />
          <h2>
            <Typed
              strings={[
                "Web Developer",
                "React Developer",
                "Front-end Developer",
                "MERN Stack Developer",
                "Javascript Developer",
                "Programmer..!",
              ]}
              typeSpeed={40}
              backSpeed={40}
              attr="placeholder"
              loop
            >
              <input className="typeInput" type="text" />
            </Typed>
          </h2>
          <small className="text-muted">
            Front end developer / MERN Stack Developer
          </small>{" "}
          <br /> <br />
          <Link to="/about">
            <Button variant="danger">Who am I ?</Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline-danger">Get In Touch</Button>
          </Link>
        </div>
        <div className="my-3 pt-3 col-md-6 d-flex justify-content-center order-1 order-md-2">
          <img className="img-fluid headerImage" src={image} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Header;
